<template>
<ConnectComponent></ConnectComponent>
</template>

<script>
import ConnectComponent from '@/components/dashboard/patientDashboard/PatientPsychologist/ConnectComponent'
export default {
  name: 'PsychologistsIndex',
  components: { ConnectComponent },
}
</script>